import React from "react";
import NumberFormat from "react-number-format";

const Currency = ({ value, unit }) => {
  let unitDefault = "Rp ";

  const prefix = unit || unitDefault;
  return (
    <NumberFormat
      displayType="text"
      thousandSeparator={"."}
      decimalSeparator={","}
      prefix={prefix}
      value={value}
    />
  );
};

export default Currency;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/dealgroup/Currency.js